import { Component, OnInit } from '@angular/core';
import { first, map } from 'rxjs/operators';
import { DbService } from 'src/app/core/services/db.service';

@Component({
  selector: 'app-show-privacy',
  templateUrl: './show-privacy.component.html',
  styleUrls: ['./show-privacy.component.scss'],
})
export class ShowPrivacyComponent implements OnInit {
  data: any;

  constructor(
    private db: DbService,
  ) { }

  async ngOnInit(): Promise<void> {
    try {
      const docData = await this.db.toDoc$(`admin/terms`);
      this.data = docData.personal;
    } catch (error) {
      console.error("데이터 가져오기 오류:", error);
      this.data = "데이터를 불러올 수 없습니다.";
    }

  }
}
